import React from "react";
import { ProgramContainer, Organization } from "../../../entities/formTemplateDataType";
import { Heading1, Heading2, OntarioRow } from "../../../theme";
import colours from "../../../theme/variables/colours";
import GradientComponent from "../../../commonComponent/GradientComponent";
import { GradientStatus, TemplateStatus } from "../../../entities/Constants";
import { Button } from "primereact/button";
import { htmlToPdf } from "../../../utilities/PdfUtils";
import { getAzureUserInfo } from "../../../security/UserComponent";
import CMAUtils from "../../../utilities/CMAUtils";
import { format } from "date-fns";

interface Props {
    isEng: boolean;
    programContainer: ProgramContainer;
    callback;
    callbackValueSaved: ()=>void;
}

interface State {
    org: Organization;
    assessmentName?: string;
    organizationName?: string;
    approvalDate?: string;
    approver?: string;
    assessor?: string;
}

export class CMAReportComponent extends React.Component<Props, State> {
    formData
    constructor(props) {
        super(props);

        this.state={
            org:null,
            assessmentName: null,
            organizationName: null,
            approvalDate: null,
            approver: null,
            assessor: null
        }
    }

    reviewPageIndex = 4;

    componentDidMount = async () => {
        const root = this.props.programContainer;
        const org = await CMAUtils.getOrganizationById(root.orgId)
        const assessmentAndApprover = await CMAUtils.getAssessmentAndApprover(root);
        this.setState({ org: org });
        this.setState({
            assessmentName: assessmentAndApprover?.assessment,
            organizationName: assessmentAndApprover?.organizationName, 
            approvalDate: assessmentAndApprover?.approvalDate, 
            approver: assessmentAndApprover?.approver, 
            assessor: assessmentAndApprover?.assessor
        });
        this.formData = await CMAUtils.retrieveFormData(root);
        
    }

    componentDidUpdate = async () => {
        if (!this.state.org) {
            const root = this.props.programContainer;
            const org = await CMAUtils.getOrganizationById(root.orgId);
            this.setState({ org: org });
            this.formData = await CMAUtils.retrieveFormData(root);
        }
    }
    stepIndicator = () => {
        return(
            <div className="ontario-step-indicator">
                <div className="ontario-row">
                    <div className="ontario-columns ontario-small-12">
                        <div className="ontario-step-indicator--with-back-button">
                            <button className="ontario-button ontario-button--tertiary"
                                 onClick={() => {
                                    CMAUtils.saveCMA(this.props.programContainer, this.props.programContainer.Entity?.status).then(success=>{if (success) this.props.callbackValueSaved()}
                                );
                                    this.props.callback();

                                }}>
                                <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                    <use href="#ontario-icon-chevron-left"></use>
                                </svg>{this.props.isEng ? "Back to dashboard" : "Retour au tableau de bord"}
                            </button>
                            {/* <span className="ontario-h4">{this.stepIndicatorTitle(this.state.stepperIndex)}</span> */}
                        </div>
                        <hr />
                    </div>
                </div>
            </div>
        );
    }

    calculateCategoryScore = (sectionIndex: number) => {
        if (sectionIndex >= this.props.programContainer.ListOfFormSections.length) return 0;
        const section = this.props.programContainer.ListOfFormSections[sectionIndex];
        const eleList = section.ListOfFormSubSections[0].ListOfFormSectionElements;
        const score = eleList.reduce((acc, ele) => acc + ele.Value?.level, 0.0) / eleList.length;
        return (Math.trunc(score*10)/10);
    }

    progressBar = () => {
        return(
            <div>
                <svg width="381" height="50" viewBox="0 0 381 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="381" height="49.9482" rx="12.7774" fill="white"/>
                    <rect x="58.0801" y="30.2012" width="249.741" height="9.29268" rx="4.64634" fill="url(#paint0_linear_1043_5155)"/>
                    <path d="M71.6451 11.9779C71.6451 12.5633 71.5816 13.0698 71.4546 13.4972C71.3307 13.9247 71.1588 14.2794 70.9389 14.5612C70.7189 14.8431 70.4603 15.0522 70.1629 15.1885C69.8656 15.3248 69.545 15.3929 69.2011 15.3929C68.8573 15.3929 68.5367 15.3248 68.2393 15.1885C67.942 15.0522 67.6833 14.8431 67.4634 14.5612C67.2466 14.2794 67.0762 13.9247 66.9523 13.4972C66.8284 13.0698 66.7664 12.5633 66.7664 11.9779C66.7664 11.3924 66.8284 10.886 66.9523 10.4585C67.0762 10.028 67.2466 9.67329 67.4634 9.39451C67.6833 9.11263 67.942 8.90355 68.2393 8.76725C68.5367 8.62786 68.8573 8.55817 69.2011 8.55817C69.545 8.55817 69.8656 8.62786 70.1629 8.76725C70.4603 8.90355 70.7189 9.11263 70.9389 9.39451C71.1588 9.67329 71.3307 10.028 71.4546 10.4585C71.5816 10.886 71.6451 11.3924 71.6451 11.9779ZM70.6136 11.9779C70.6136 11.4823 70.5733 11.0703 70.4928 10.7419C70.4154 10.4105 70.3116 10.1457 70.1815 9.94742C70.0514 9.74918 69.9012 9.60824 69.7308 9.52461C69.5604 9.44097 69.3839 9.39916 69.2011 9.39916C69.0153 9.39916 68.8372 9.44097 68.6668 9.52461C68.4995 9.60824 68.3508 9.74918 68.2208 9.94742C68.0907 10.1457 67.9869 10.4105 67.9094 10.7419C67.832 11.0703 67.7933 11.4823 67.7933 11.9779C67.7933 12.4735 67.832 12.887 67.9094 13.2184C67.9869 13.5468 68.0907 13.8101 68.2208 14.0083C68.3508 14.2066 68.4995 14.3475 68.6668 14.4311C68.8372 14.5148 69.0153 14.5566 69.2011 14.5566C69.3839 14.5566 69.5604 14.5148 69.7308 14.4311C69.9012 14.3475 70.0514 14.2066 70.1815 14.0083C70.3116 13.8101 70.4154 13.5468 70.4928 13.2184C70.5733 12.887 70.6136 12.4735 70.6136 11.9779ZM73.0351 12.1033H75.3908V12.949H73.0351V12.1033ZM81.2923 14.5659V15.3232H77.6449V14.5659H79.0388V10.3749C79.0388 10.2262 79.0435 10.0744 79.0528 9.91955L77.9794 10.8256C77.933 10.8628 77.885 10.8875 77.8354 10.8999C77.7889 10.9092 77.744 10.9092 77.7007 10.8999C77.6604 10.8906 77.6232 10.8767 77.5892 10.8581C77.5582 10.8364 77.5334 10.8132 77.5148 10.7884L77.2035 10.3517L79.22 8.61857H80.0331V14.5659H81.2923Z" fill="#6F6F6F"/>
                    <rect x="72.4688" y="23.6465" width="3.48476" height="3.48476" rx="1.74238" fill="#CD0000"/>
                    <path d="M124.714 14.5659V15.3232H121.067V14.5659H122.461V10.3749C122.461 10.2262 122.466 10.0744 122.475 9.91955L121.401 10.8256C121.355 10.8628 121.307 10.8875 121.257 10.8999C121.211 10.9092 121.166 10.9092 121.123 10.8999C121.082 10.8906 121.045 10.8767 121.011 10.8581C120.98 10.8364 120.955 10.8132 120.937 10.7884L120.626 10.3517L122.642 8.61857H123.455V14.5659H124.714ZM126.467 12.1033H128.822V12.949H126.467V12.1033ZM134.524 14.38C134.633 14.38 134.718 14.4126 134.78 14.4776C134.842 14.5396 134.873 14.6201 134.873 14.7192V15.3232H130.347V14.9841C130.347 14.9159 130.361 14.8447 130.389 14.7703C130.417 14.696 130.462 14.6278 130.524 14.5659L132.605 12.4797C132.782 12.3031 132.938 12.1343 133.074 11.9732C133.214 11.8122 133.332 11.6511 133.428 11.49C133.527 11.3289 133.601 11.1663 133.651 11.0021C133.703 10.8349 133.73 10.6599 133.73 10.4771C133.73 10.3005 133.702 10.1457 133.646 10.0125C133.593 9.87618 133.519 9.76467 133.423 9.67794C133.33 9.58811 133.217 9.52151 133.084 9.47814C132.954 9.43168 132.81 9.40845 132.652 9.40845C132.5 9.40845 132.359 9.43013 132.229 9.4735C132.102 9.51686 131.987 9.57727 131.885 9.65471C131.786 9.73214 131.702 9.82507 131.634 9.93349C131.569 10.0388 131.521 10.155 131.49 10.282C131.444 10.409 131.383 10.4941 131.309 10.5375C131.238 10.5809 131.132 10.5902 130.993 10.5654L130.468 10.4725C130.514 10.1565 130.601 9.87928 130.728 9.64077C130.858 9.40225 131.021 9.20401 131.216 9.04603C131.411 8.88496 131.634 8.76416 131.885 8.68362C132.139 8.59999 132.413 8.55817 132.707 8.55817C133.005 8.55817 133.277 8.60308 133.525 8.69291C133.776 8.77964 133.991 8.9051 134.171 9.06927C134.354 9.23034 134.496 9.42703 134.598 9.65935C134.701 9.89167 134.752 10.1534 134.752 10.4446C134.752 10.6924 134.715 10.9216 134.64 11.1322C134.569 11.3429 134.471 11.5442 134.348 11.7363C134.224 11.9283 134.078 12.1157 133.911 12.2985C133.747 12.4781 133.573 12.6609 133.39 12.8467L131.774 14.5008C131.907 14.4637 132.04 14.4342 132.173 14.4126C132.309 14.3909 132.438 14.38 132.559 14.38H134.524Z" fill="#6F6F6F"/>
                    <rect x="125.9" y="23.6465" width="3.48476" height="3.48476" rx="1.74238" fill="#E65D0C"/>
                    <path d="M177.948 14.38C178.057 14.38 178.142 14.4126 178.204 14.4776C178.266 14.5396 178.297 14.6201 178.297 14.7192V15.3232H173.771V14.9841C173.771 14.9159 173.785 14.8447 173.813 14.7703C173.841 14.696 173.886 14.6278 173.948 14.5659L176.029 12.4797C176.206 12.3031 176.362 12.1343 176.498 11.9732C176.638 11.8122 176.756 11.6511 176.852 11.49C176.951 11.3289 177.025 11.1663 177.075 11.0021C177.127 10.8349 177.154 10.6599 177.154 10.4771C177.154 10.3005 177.126 10.1457 177.07 10.0125C177.017 9.87618 176.943 9.76467 176.847 9.67794C176.754 9.58811 176.641 9.52151 176.508 9.47814C176.378 9.43168 176.234 9.40845 176.076 9.40845C175.924 9.40845 175.783 9.43013 175.653 9.4735C175.526 9.51686 175.411 9.57727 175.309 9.65471C175.21 9.73214 175.126 9.82507 175.058 9.93349C174.993 10.0388 174.945 10.155 174.914 10.282C174.868 10.409 174.807 10.4941 174.733 10.5375C174.662 10.5809 174.556 10.5902 174.417 10.5654L173.892 10.4725C173.938 10.1565 174.025 9.87928 174.152 9.64077C174.282 9.40225 174.445 9.20401 174.64 9.04603C174.835 8.88496 175.058 8.76416 175.309 8.68362C175.563 8.59999 175.837 8.55817 176.131 8.55817C176.429 8.55817 176.701 8.60308 176.949 8.69291C177.2 8.77964 177.415 8.9051 177.595 9.06927C177.778 9.23034 177.92 9.42703 178.022 9.65935C178.125 9.89167 178.176 10.1534 178.176 10.4446C178.176 10.6924 178.139 10.9216 178.064 11.1322C177.993 11.3429 177.895 11.5442 177.772 11.7363C177.648 11.9283 177.502 12.1157 177.335 12.2985C177.171 12.4781 176.997 12.6609 176.814 12.8467L175.197 14.5008C175.331 14.4637 175.464 14.4342 175.597 14.4126C175.733 14.3909 175.862 14.38 175.983 14.38H177.948ZM179.9 12.1033H182.256V12.949H179.9V12.1033ZM183.934 10.4725C183.98 10.1565 184.067 9.87928 184.194 9.64077C184.324 9.40225 184.487 9.20401 184.682 9.04603C184.877 8.88496 185.1 8.76416 185.351 8.68362C185.605 8.59999 185.879 8.55817 186.174 8.55817C186.471 8.55817 186.74 8.60153 186.982 8.68827C187.227 8.7719 187.436 8.88961 187.609 9.04139C187.786 9.19317 187.921 9.37438 188.013 9.58501C188.11 9.79564 188.158 10.0264 188.158 10.2773C188.158 10.491 188.131 10.68 188.079 10.8442C188.029 11.0052 187.956 11.1477 187.86 11.2716C187.767 11.3955 187.653 11.4993 187.516 11.5829C187.38 11.6666 187.227 11.7363 187.056 11.792C187.471 11.9128 187.783 12.1064 187.99 12.3728C188.198 12.6361 188.302 12.9675 188.302 13.3671C188.302 13.6893 188.241 13.9758 188.12 14.2267C188 14.4776 187.835 14.6898 187.628 14.8633C187.423 15.0367 187.183 15.1699 186.908 15.2628C186.635 15.3527 186.345 15.3976 186.039 15.3976C185.695 15.3976 185.398 15.3573 185.147 15.2768C184.896 15.1931 184.679 15.0754 184.496 14.9237C184.317 14.7688 184.166 14.5829 184.046 14.3661C183.925 14.1493 183.822 13.9061 183.739 13.6366L184.171 13.4554C184.286 13.4059 184.394 13.3919 184.496 13.4136C184.602 13.4353 184.677 13.4926 184.724 13.5855C184.773 13.6846 184.829 13.7915 184.891 13.9061C184.953 14.0176 185.032 14.1214 185.128 14.2174C185.227 14.3103 185.348 14.3893 185.491 14.4544C185.636 14.5163 185.814 14.5473 186.025 14.5473C186.239 14.5473 186.424 14.5132 186.582 14.4451C186.743 14.3738 186.877 14.284 186.982 14.1756C187.09 14.0641 187.171 13.9402 187.224 13.8039C187.276 13.6676 187.303 13.5329 187.303 13.3997C187.303 13.2324 187.282 13.0791 187.242 12.9397C187.202 12.7972 187.123 12.6764 187.005 12.5773C186.891 12.4781 186.726 12.4007 186.513 12.3449C186.302 12.2861 186.025 12.2567 185.681 12.2567V11.5365C185.963 11.5334 186.2 11.5055 186.392 11.4528C186.587 11.3971 186.742 11.3227 186.857 11.2298C186.974 11.1338 187.058 11.0192 187.107 10.886C187.16 10.7528 187.186 10.6072 187.186 10.4492C187.186 10.2789 187.16 10.1286 187.107 9.99853C187.055 9.86844 186.98 9.76002 186.884 9.67329C186.791 9.58346 186.68 9.51686 186.55 9.4735C186.42 9.43013 186.276 9.40845 186.118 9.40845C185.966 9.40845 185.825 9.43013 185.695 9.4735C185.568 9.51686 185.453 9.57727 185.351 9.65471C185.252 9.73214 185.168 9.82507 185.1 9.93349C185.032 10.0388 184.983 10.155 184.952 10.282C184.908 10.409 184.849 10.4941 184.775 10.5375C184.704 10.5809 184.598 10.5902 184.459 10.5654L183.934 10.4725Z" fill="#6F6F6F"/>
                    <rect x="179.334" y="23.6465" width="3.48476" height="3.48476" rx="1.74238" fill="#FAA716"/>
                    <path d="M227.358 10.4725C227.404 10.1565 227.491 9.87928 227.618 9.64077C227.748 9.40225 227.911 9.20401 228.106 9.04603C228.301 8.88496 228.524 8.76416 228.775 8.68362C229.029 8.59999 229.303 8.55817 229.598 8.55817C229.895 8.55817 230.164 8.60153 230.406 8.68827C230.651 8.7719 230.86 8.88961 231.033 9.04139C231.21 9.19317 231.345 9.37438 231.437 9.58501C231.534 9.79564 231.582 10.0264 231.582 10.2773C231.582 10.491 231.555 10.68 231.503 10.8442C231.453 11.0052 231.38 11.1477 231.284 11.2716C231.191 11.3955 231.077 11.4993 230.94 11.5829C230.804 11.6666 230.651 11.7363 230.48 11.792C230.895 11.9128 231.207 12.1064 231.414 12.3728C231.622 12.6361 231.726 12.9675 231.726 13.3671C231.726 13.6893 231.665 13.9758 231.544 14.2267C231.424 14.4776 231.259 14.6898 231.052 14.8633C230.847 15.0367 230.607 15.1699 230.332 15.2628C230.059 15.3527 229.769 15.3976 229.463 15.3976C229.119 15.3976 228.822 15.3573 228.571 15.2768C228.32 15.1931 228.103 15.0754 227.92 14.9237C227.741 14.7688 227.59 14.5829 227.47 14.3661C227.349 14.1493 227.246 13.9061 227.163 13.6366L227.595 13.4554C227.71 13.4059 227.818 13.3919 227.92 13.4136C228.026 13.4353 228.101 13.4926 228.148 13.5855C228.197 13.6846 228.253 13.7915 228.315 13.9061C228.377 14.0176 228.456 14.1214 228.552 14.2174C228.651 14.3103 228.772 14.3893 228.915 14.4544C229.06 14.5163 229.238 14.5473 229.449 14.5473C229.663 14.5473 229.848 14.5132 230.006 14.4451C230.167 14.3738 230.301 14.284 230.406 14.1756C230.514 14.0641 230.595 13.9402 230.648 13.8039C230.7 13.6676 230.727 13.5329 230.727 13.3997C230.727 13.2324 230.706 13.0791 230.666 12.9397C230.626 12.7972 230.547 12.6764 230.429 12.5773C230.315 12.4781 230.15 12.4007 229.937 12.3449C229.726 12.2861 229.449 12.2567 229.105 12.2567V11.5365C229.387 11.5334 229.624 11.5055 229.816 11.4528C230.011 11.3971 230.166 11.3227 230.281 11.2298C230.398 11.1338 230.482 11.0192 230.531 10.886C230.584 10.7528 230.61 10.6072 230.61 10.4492C230.61 10.2789 230.584 10.1286 230.531 9.99853C230.479 9.86844 230.404 9.76002 230.308 9.67329C230.215 9.58346 230.104 9.51686 229.974 9.4735C229.844 9.43013 229.7 9.40845 229.542 9.40845C229.39 9.40845 229.249 9.43013 229.119 9.4735C228.992 9.51686 228.877 9.57727 228.775 9.65471C228.676 9.73214 228.592 9.82507 228.524 9.93349C228.456 10.0388 228.407 10.155 228.376 10.282C228.332 10.409 228.273 10.4941 228.199 10.5375C228.128 10.5809 228.022 10.5902 227.883 10.5654L227.358 10.4725ZM233.334 12.1033H235.69V12.949H233.334V12.1033ZM240.169 12.8514V10.4074C240.169 10.2123 240.183 9.99853 240.211 9.76622L237.962 12.8514H240.169ZM241.963 12.8514V13.4275C241.963 13.4833 241.944 13.5313 241.907 13.5716C241.873 13.6118 241.82 13.632 241.749 13.632H241.038V15.3232H240.169V13.632H237.275C237.203 13.632 237.141 13.6118 237.089 13.5716C237.039 13.5282 237.007 13.4755 236.991 13.4136L236.889 12.9025L240.1 8.62786H241.038V12.8514H241.963Z" fill="#6F6F6F"/>
                    <rect x="232.768" y="23.6465" width="3.48476" height="3.48476" rx="1.74238" fill="#A0A02A"/>
                    <path d="M283.591 12.8514V10.4074C283.591 10.2123 283.605 9.99853 283.633 9.76622L281.384 12.8514H283.591ZM285.385 12.8514V13.4275C285.385 13.4833 285.366 13.5313 285.329 13.5716C285.295 13.6118 285.242 13.632 285.171 13.632H284.46V15.3232H283.591V13.632H280.697C280.625 13.632 280.564 13.6118 280.511 13.5716C280.461 13.5282 280.429 13.4755 280.413 13.4136L280.311 12.9025L283.522 8.62786H284.46V12.8514H285.385ZM286.766 12.1033H289.121V12.949H286.766V12.1033ZM292.04 11.1044C292.201 11.0703 292.354 11.0455 292.5 11.03C292.648 11.0145 292.791 11.0068 292.927 11.0068C293.277 11.0068 293.585 11.0594 293.852 11.1648C294.121 11.267 294.346 11.4095 294.526 11.5922C294.708 11.775 294.845 11.9903 294.934 12.2381C295.027 12.4828 295.074 12.7492 295.074 13.0372C295.074 13.3935 295.012 13.7172 294.888 14.0083C294.764 14.2995 294.592 14.5489 294.372 14.7564C294.152 14.9608 293.892 15.1188 293.592 15.2303C293.294 15.3418 292.972 15.3976 292.625 15.3976C292.421 15.3976 292.226 15.3774 292.04 15.3372C291.857 15.2969 291.685 15.2427 291.524 15.1746C291.363 15.1033 291.214 15.0228 291.078 14.9329C290.942 14.84 290.819 14.744 290.711 14.6449L291.018 14.2174C291.083 14.1245 291.169 14.078 291.278 14.078C291.346 14.078 291.42 14.1028 291.501 14.1524C291.581 14.2019 291.674 14.2561 291.78 14.315C291.888 14.3707 292.015 14.4234 292.161 14.473C292.306 14.5225 292.48 14.5473 292.681 14.5473C292.901 14.5473 293.098 14.5117 293.271 14.4404C293.445 14.3692 293.59 14.2701 293.708 14.1431C293.829 14.013 293.92 13.8581 293.982 13.6784C294.044 13.4988 294.075 13.3021 294.075 13.0884C294.075 12.8932 294.045 12.7182 293.987 12.5633C293.931 12.4084 293.846 12.2768 293.731 12.1684C293.62 12.06 293.479 11.9779 293.308 11.9221C293.138 11.8633 292.941 11.8338 292.718 11.8338C292.554 11.8338 292.385 11.8478 292.212 11.8757C292.041 11.9035 291.868 11.9469 291.691 12.0058L291.069 11.8292L291.617 8.63251H294.855V9.06462C294.855 9.20711 294.811 9.32327 294.721 9.4131C294.631 9.50293 294.481 9.54784 294.27 9.54784H292.309L292.04 11.1044Z" fill="#6F6F6F"/>
                    <rect x="286.199" y="23.6465" width="3.48476" height="3.48476" rx="1.74238" fill="#338E40"/>
                    <defs>
                    <linearGradient id="paint0_linear_1043_5155" x1="58.0801" y1="34.8475" x2="307.821" y2="34.8475" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#CD0000"/>
                    <stop offset="0.525" stop-color="#FCAF17"/>
                    <stop offset="1" stop-color="#118847"/>
                    </linearGradient>
                    </defs>
                </svg>

            </div>
        );
    }

    calculateFunctionScore = (functionIndex: number) => {
        let startIndex = this.reviewPageIndex+1;
        // const currentTemplate = this.props.programContainer.CMATemplateList[0];
        const currentTemplate = this.props.programContainer.Template;
        const functions = this.props.programContainer.CMATemplateList.filter(t=>t.Name==currentTemplate)[0].Functions;
        startIndex = functions.slice(0, functionIndex)
            .reduce((acc, f) => 
                acc + f.CategoryDetailList.length,
                startIndex
            );
        let endIndex = startIndex + functions[functionIndex].CategoryDetailList.length - 1;
        
        let questionCount = 0;
        let totalScore = 0;
        const sectionList = this.props.programContainer.ListOfFormSections;
        for (let i=startIndex; i <= endIndex; i++) {
            const eleList = sectionList[i].ListOfFormSubSections[0].ListOfFormSectionElements;
            totalScore = eleList.reduce((acc, ele) => acc + ele.Value?.level, totalScore);
            questionCount = questionCount + eleList.length;
        }
        return (Math.trunc((totalScore/questionCount)*10)/10);
    }

    calculateOverallScore = () => {
        const currentTemplate = this.props.programContainer.Template;
        const functions = this.props.programContainer.CMATemplateList.filter(t=>t.Name==currentTemplate)[0].Functions;
        const totalScore = functions.reduce((acc, func, findex) => 
            this.calculateFunctionScore(findex) + acc,
            0
        );
        return (Math.trunc((totalScore/functions.length)*10)/10);
    }

    getScoreRange = (score: number) => {
        if (Math.floor(score) === Math.ceil(score)) {
            if (score === 0 || score === 1)  {
                return ["0-1"];
            }
            return [`${Math.ceil(score)-1}-${Math.ceil(score)}`];
        }
        return [`${Math.floor(score)}-${Math.ceil(score)}`];
    }

    downloadReportPDF = () => {
        console.log("Download PDF");
        const pdfElement = document.querySelector('main');
        // const cloneElement = document.querySelector('main');;
        const cloneElement = pdfElement.cloneNode(true) as HTMLElement;
        cloneElement.style.fontSize = '14px';
        const title = cloneElement.querySelector('div#cma-report-header>h1');
        title.insertAdjacentHTML("afterend", `<h3>${title.innerHTML}</h3>`);
        cloneElement.querySelectorAll('div#cma-report-header>p, div#cma-report-info>p').forEach((ele) => {
            (ele as HTMLElement).style.fontSize = '1rem';
        });
        (cloneElement.querySelector('#cma-download-btn') as HTMLElement).remove(); // .style.display = 'none';
        (cloneElement.querySelector('div#categroy-rating-table') as HTMLElement).style.marginBottom = '0';
        (cloneElement.querySelector('div.ontario-step-indicator') as HTMLElement).style.display = 'none';
        cloneElement.querySelectorAll('table').forEach((table) => {
            table.style.fontSize = '0.7rem';
            table.style.marginBottom = '2.5rem';
            table.style.maxWidth = '50rem';
            // table.style.borderCollapse = 'collapse';
            table.style.borderSpacing = '0';
            table.style.width = '100%';
            if (table.id !== 'cma-report-table') {
                table.removeAttribute('id');
            }
           
        });
        cloneElement.querySelectorAll('thead th, tbody th, tbody td').forEach((col) => {
            (col as HTMLElement).style.fontSize='0.7rem';
            (col as HTMLElement).style.padding ='1rem 0.5rem';
        });
        // cloneElement.querySelectorAll('tbody tr:last-child').forEach((col) => {
        //     (col as HTMLElement).style.borderBottom = '3px solid #1a1a1a';
        // });

        cloneElement.querySelectorAll('table#cma-report-table tbody tr').forEach((row: HTMLTableRowElement) => {
            if (row.classList.contains('cam-las-func-row')) {
                let cells = row.querySelectorAll('td');
                cells.forEach((cell: HTMLTableCellElement) => {
                    cell.style.background = 'none';
                });
                row.style.borderBottom = '3px solid #1a1a1a';
            } else {
                const cells = row.querySelectorAll('td').forEach((cell: HTMLTableCellElement) => {
                    cell.style.background = 'none';
                    cell.style.borderBottom = '1px solid #c5c5c5';
                });
            }
        });
        
        cloneElement.querySelectorAll('table#cma-report-table thead tr').forEach((head: HTMLTableRowElement) => {
            head.style.borderBottom = '1px solid #e6e6e6';
        });

        const table = cloneElement.querySelector('table#cma-report-table') as HTMLTableElement;
        if (table) {
            table.removeAttribute('id');
        }
        title.remove();
        
        htmlToPdf(cloneElement, this.props.isEng);
    }

    render() {
        let htmlString = [];
        let bodyContent = [];
        let sectionIndex = this.reviewPageIndex + 1;
        const currentTemplate = this.props.programContainer.Template;
        const functions = this.props.programContainer.CMATemplateList.filter(t=>t.Name==currentTemplate)[0].Functions;
        const organization = this.state.org;
        const currentUser = getAzureUserInfo();
        const overall = this.calculateOverallScore();

        htmlString.push(this.stepIndicator());

        const entity = this.props.programContainer.Entity;
        const approved = entity?.status === TemplateStatus.SUBMITTED || entity?.status === TemplateStatus.COMPLETED;
        const approver = this.state.org?.csPersonal; //CMAUtils.getApproverName(this.state.org, entity.updatedById);
        const approvalDate = entity.updatedDate;
        const approverName = approver? `${approver?.firstName} ${approver?.lastName}`:null;

        const fullName = currentUser?.name
        const [last, rest] = fullName.split(',');
        const first = rest.split('(')[0].trim();
        if (this.props.isEng) {
            htmlString.push(
            <>
                <div id="cma-report-header">
                    <Heading1> {this.state.organizationName || this.props.programContainer?.organizationName} </Heading1>
                    <OntarioRow><span style={{ fontWeight: 'bold' }}>Sector: </span>{organization?.sector}</OntarioRow>
                    <OntarioRow><span style={{ fontWeight: 'bold' }}>CMA Template: </span>{currentTemplate}</OntarioRow>
                    <OntarioRow>
                        <span style={{ fontWeight: 'bold' }}>Approval Date: </span>
                        {approved ? this.state.approvalDate ? format(this.state.approvalDate , 'dd/MM/yyyy'): '' : ''}
                    </OntarioRow>
                    <OntarioRow>
                        <span style={{ fontWeight: 'bold' }}>Approved By: </span>
                        {approved ?  this.state.approver ?? '' : ''}
                    </OntarioRow>
                    <OntarioRow><span style={{ fontWeight: 'bold' }}>Assessment By: </span>{this.state.assessor ?? ''}</OntarioRow>
                </div>
                <div id="cma-report-info" className="ontario-margin-top-24-!">
                    This Cyber Security Maturity Assessment (CMA) summary report provides an overview of the organization's current cyber security posture, and highlights areas for improvement based on the National Institute of Standards and Technology  (NIST) Cybersecurity Framework (CSF) 2.0. The assessment includes outcome statements for each NIST framework category, rated on a scale from 0 (Nonexistent) to 5 (Optimized). The ratings below reflect the average of all responses within that category, and the overall rating represents the average of all responses. Refer to Appendix A for the rating legend and definitions.
                </div>
            </>
            );

            
            htmlString.push(
                <div id="overall-score-table" className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
                    <div className="ontario-table-div">
                    <p style={{ fontWeight: 'bold', marginTop: "2em", marginBottom: "0.5em"}}>Overall CMA Score</p>
                        <table className=" ontario-table--full-container-width">
                            <caption></caption>
                            <thead>
                                <tr>
                                    <th scope="col">Entity Name</th>
                                    <th scope="col">Maturity Level</th>
                                    <th scope="col">Overall Rating</th>
                                    <th scope="col">Rating Bar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">{organization?.organizationName ?? ''}</th>
                                    <td>{this.props.programContainer.CMAOptionList?.[Math.floor(overall)]?.label ?? ''}</td>
                                    <td className="ontario-table-cell--numeric" style={{textAlign: 'center'}}>{overall.toFixed(1)}</td>
                                    <td>
                                        <GradientComponent
                                            descs={[overall.toFixed(1)]}
                                            descColor={GradientStatus.getColor(overall)}
                                            colors={GradientStatus.getColors()}
                                            direction="to right"
                                            type='frame'
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <p style={{fontWeight: 'bold', marginTop: "2.5em", marginBottom: "0.1em"}}> Approval Remarks</p>
                        <OntarioRow>{this.props.programContainer?.Entity?.approvalNotes || "No remarks at this time."}</OntarioRow>
                    </div>
                </div>
            );

            functions.forEach((f, findex) => {
                f.CategoryDetailList.forEach((c, cindex) => {
                    const score = this.calculateCategoryScore(sectionIndex++);
                    const maturatyLevel = this.props.programContainer.CMAOptionList.filter(option => option.level == Math.trunc(score))[0]?.label ?? '';
                    bodyContent.push(
                        <tr style={{backgroundColor: '#fff'}} className={cindex === (f.CategoryDetailList.length - 1) ? 'cam-las-func-row' : ''}>
                            {cindex === 0 ? <th scope="row">{`Function ${findex +1}: ${f.FunctionName}`}</th> : <td></td>}
                            <td style={{backgroundColor: colours.palette.greyscale5}} scope="row">{c.CategoryName}</td>
                            <td style={{backgroundColor: colours.palette.greyscale5, textAlign: 'center', fontWeight: "bold"}} className="ontario-table-cell--numeric">{score.toFixed(1)}</td>
                            <td style={{backgroundColor: colours.palette.greyscale5}}>{maturatyLevel}</td>
                            <td style={{backgroundColor: colours.palette.greyscale5}}>
                                <GradientComponent 
                                    descs={[score.toFixed(1)]}
                                    descColor={GradientStatus.getColor(score)}
                                    colors={GradientStatus.getColors()}
                                    type='frame'
                                    direction="to right"
                                />
                            </td>
                        </tr>
                    );
                });
            });

            htmlString.push(
                <div id="categroy-rating-table" className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
                    
                    <div className="ontario-table-div">
                        <p style={{fontWeight: 'bold', marginBottom: '0.1em', marginTop: '1em'}}>CMA Details</p>
                        <table className=" ontario-table--full-container-width cma-report-table"  id="cma-report-table">
                            <thead>
                                <tr>
                                    <th scope="col">Function</th>
                                    <th scope="col">Category</th>
                                    <th scope="col">Rating</th>
                                    <th scope="col">Maturity Level</th>
                                    {/* <th scope="col">{this.progressBar()}</th> */}
                                    <th scope="col">Rating Bar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bodyContent}
                            </tbody>
                        </table>
                    </div>

                    <div className="ontario-table-div">
                        <p style={{fontWeight: 'bold', marginBottom: '0.1em', marginTop: '3em'}}>Rating Bar Scale</p>
                        <table className="ontario-table--full-container-width" id="cma-gradient-table" style={{marginBottom: "3em"}}>
                            <thead>
                                <tr>
                                <th scope="col" style={{width: "16.6%"}}>Non-existent</th>
                                <th scope="col" style={{width: "16.6%"}}>Initial</th>
                                <th scope="col" style={{width: "16.6%"}}>Managed</th>
                                <th scope="col" style={{width: "16.6%"}}>Defined</th>
                                <th scope="col" style={{width: "16.6%"}}>Quantitively Managed</th>
                                <th scope="col" style={{width: "16.6%"}}>Optimized</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>0</td>
                                <td>1</td>
                                <td>2</td>
                                <td>3</td>
                                <td>4</td>
                                <td>5</td>
                                </tr>
                                <tr>
                                <td colSpan={6}>
                                    <GradientComponent
                                        labels={[]}
                                        descs={[]}
                                        colors={GradientStatus.getColors()}
                                        direction="to right"
                                        type='general'
                                    />
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            );

            htmlString.push(
                <>
                    <div className="appendix-details">
                        <p></p>
                        <Heading2 style={{marginTop: '5em'}}>Appendix A - CMA Reference Details</Heading2>
                        <OntarioRow style={{marginBottom: '1.5em'}}>This CMA self-assessment was completed and approved by the authorized representatives listed above, with support from additional contributors within the organization, as applicable.</OntarioRow>
                        <OntarioRow style={{marginBottom: '1.5em'}}>To self-assess cyber security maturity, the CMA leveraged more than 100 statements based on the NIST Cybersecurity Framework 2.0. It was adapted for regional and organizational contexts with permission from the National Institute of Standards and Technology (2024).</OntarioRow>

                    </div>
                    <div className="nist-functions">
                        <span style={{fontWeight: 'bold'}}>NIST CSF 2.0 Functions</span>
                        <p> GOVERN - The organization's cyber security risk management strategy, expectations, and policy are established, communicated, and monitored. </p>
                        <p> IDENTIFY - The organization's current cyber security risks are understood. </p>
                        <p> PROTECT - Safeguards to manage the organization's cyber security risks are used. </p>
                        <p> DETECT - Possible cyber security attacks and compromises are found and analyzed. </p>
                        <p> RESTORE - Actions regarding a detected cyber security incident are taken. </p>
                        <p> RECOVER - Assets and operations affected by a cyber security incident are restored. </p>
                    </div>  

                    <div className="ontario-table-div">
                        <table className="ontario-table--full-container-width" style={{ marginBottom: "3em" }}>
                            <thead>
                                <tr>
                                    <th scope="col">Rating</th>
                                    <th scope="col">Maturity Level</th>
                                    <th scope="col">Brief Definition</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>0</td>
                                    <td>Nonexistent</td>
                                    <td>There is no informal or reactive measures and no governance or documented cyber security practices.</td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>Initial</td>
                                    <td>Existing processes are ad hoc, unpredictable, poorly controlled, and reactive. There is little to no formal governance, no documented security policies, and controls vary widely by teams or across the organization.</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Managed</td>
                                    <td>Basic processes management and governance exists. However, improvements are reactive, and standards and controls are not uniformly enforced.</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Defined</td>
                                    <td>Processes are standardized, integrated and communicated across the organization. They are defined, documented, and implemented as intended, such as through a common framework or playbook.</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Quantitatively Managed</td>
                                    <td>Performance is monitored and measured regularly, and risks are predicted using metrics and trend analysis. Continuous improvement is guided by data-driven insights.</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Optimizing</td>
                                    <td>Continuous improvement is embedded in the organization's culture and organizational alignment. The organization proactively innovates, anticipating future risks and adapting quickly.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </>
            );
        }
        else {
            let sectorFRA = this.props.programContainer.SectorOptions.filter(s => s.code == organization?.sector)[0]?.FRA ?? organization?.sector;
            htmlString.push(
            <>
                <div id="cma-report-header">
                    <Heading1> {this.props.programContainer?.organizationName} </Heading1>
                    <OntarioRow><span style={{ fontWeight: 'bold' }}>Secteur : </span>{sectorFRA}</OntarioRow>
                    <OntarioRow><span style={{ fontWeight: 'bold' }}>Modèle d’ECM : </span>{currentTemplate}</OntarioRow>
                    <OntarioRow>
                        <span style={{ fontWeight: 'bold' }}>Date d'approbation : </span>
                        {approved ? this.state.approvalDate ? format(this.state.approvalDate , 'dd/MM/yyyy'): '' : ''}
                    </OntarioRow>
                    <OntarioRow>
                        <span style={{ fontWeight: 'bold' }}>Approuvé par : </span>
                        {approved ?  this.state.approver ?? '' : ''}
                    </OntarioRow>
                    <OntarioRow><span style={{ fontWeight: 'bold' }}>Évaluation par : </span>{this.state.assessor ?? ''}</OntarioRow>
                </div>
                <div id="cma-report-info" className="ontario-margin-top-24-!">
                    Le présent rapport de synthèse de l’évaluation de la cybermaturité (ECM) donne une vue d’ensemble de la situation actuelle de l’organisation en matière de cybersécurité et met en évidence les domaines à améliorer en fonction du Cybersecurity Framework (CSF) 2.0 du National Institute of Standards and Technology (NIST). L’évaluation comprend des énoncés de résultats pour chaque catégorie du cadre du NIST, cotés sur une échelle de 0 (aucune) à 5 (optimisée). Les cotations ci-dessous reflètent la moyenne de toutes les réponses dans cette catégorie, et la cotation globale représente la moyenne de toutes les réponses. Veuillez vous reporter à l’annexe A pour consulter la légende et les définitions liées aux cotations.
                </div>
            </>
            );

            
            htmlString.push(
                <div id="overall-score-table" className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
                    <div className="ontario-table-div">
                    <p style={{ fontWeight: 'bold', marginTop: "2em", marginBottom: "0.5em"}}>Score global de l’ECM</p>
                        <table className=" ontario-table--full-container-width">
                            <caption></caption>
                            <thead>
                                <tr>
                                    <th scope="col">Nom de l’entité</th>
                                    <th scope="col">Niveau de maturité</th>
                                    <th scope="col">Cotation globale</th>
                                    <th scope="col">Échelle d’évaluation</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">{organization?.organizationName ?? ''}</th>
                                    <td>{this.props.programContainer.CMAOptionList?.[Math.floor(overall)]?.labelFRA ?? ''}</td>
                                    <td className="ontario-table-cell--numeric" style={{textAlign: 'center'}}>{overall.toFixed(1)}</td>
                                    <td>
                                        <GradientComponent
                                            descs={[overall.toFixed(1)]}
                                            descColor={GradientStatus.getColor(overall)}
                                            colors={GradientStatus.getColors()}
                                            direction="to right"
                                            type='frame'
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <p style={{fontWeight: 'bold', marginTop: "2.5em", marginBottom: "0.1em"}}>Remarques sur l’approbation</p>
                        <OntarioRow>{this.props.programContainer?.Entity?.approvalNotes || "Aucune remarque pour le moment."}</OntarioRow>
                    </div>
                </div>
            );

            functions.forEach((f, findex) => {
                let functionNameFRA = this.props.programContainer.FunctionNameList.filter(fn => fn.code === f.FunctionName)[0]?.FRA || f.FunctionName;
                f.CategoryDetailList.forEach((c, cindex) => {
                    const score = this.calculateCategoryScore(sectionIndex++);
                    let categoryNameFRA = this.props.programContainer.CategoryNameList.filter(cn => cn.code === c.CategoryName)[0]?.FRA || c.CategoryName;
                    const maturatyLevel = this.props.programContainer.CMAOptionList.filter(option => option.level == Math.trunc(score))[0]?.labelFRA ?? '';
                    bodyContent.push(
                        <tr style={{backgroundColor: '#fff'}} className={cindex === (f.CategoryDetailList.length - 1) ? 'cam-las-func-row' : ''}>
                            {cindex === 0 ? <th scope="row">{`Fonction ${findex +1} : ${functionNameFRA}`}</th> : <td></td>}
                            <td style={{backgroundColor: colours.palette.greyscale5}} scope="row">{categoryNameFRA}</td>
                            <td style={{backgroundColor: colours.palette.greyscale5, textAlign: 'center', fontWeight: "bold"}} className="ontario-table-cell--numeric">{score.toFixed(1)}</td>
                            <td style={{backgroundColor: colours.palette.greyscale5}}>{maturatyLevel}</td>
                            <td style={{backgroundColor: colours.palette.greyscale5}}>
                                <GradientComponent 
                                    descs={[score.toFixed(1)]}
                                    descColor={GradientStatus.getColor(score)}
                                    colors={GradientStatus.getColors()}
                                    type='frame'
                                    direction="to right"
                                />
                            </td>
                        </tr>
                    );
                });
            });

            htmlString.push(
                <div id="categroy-rating-table" className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
                    
                    <div className="ontario-table-div">
                        <p style={{fontWeight: 'bold', marginBottom: '0.1em', marginTop: '1em'}}>Détails de l’ECM</p>
                        <table className=" ontario-table--full-container-width cma-report-table"  id="cma-report-table">
                            <thead>
                                <tr>
                                    <th scope="col">Fonction</th>
                                    <th scope="col">Catégorie</th>
                                    <th scope="col">Cotation</th>
                                    <th scope="col">Niveau de maturité</th>
                                    {/* <th scope="col">{this.progressBar()}</th> */}
                                    <th scope="col">Échelle d’évaluation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bodyContent}
                            </tbody>
                        </table>
                    </div>

                    <div className="ontario-table-div">
                        <p style={{fontWeight: 'bold', marginBottom: '0.1em', marginTop: '3em'}}>Échelle d’évaluation</p>
                        <table className="ontario-table--full-container-width" id="cma-gradient-table" style={{marginBottom: "3em"}}>
                            <thead>
                                <tr>
                                <th scope="col" style={{width: "16.6%"}}>Aucune</th>
                                <th scope="col" style={{width: "16.6%"}}>Initiale</th>
                                <th scope="col" style={{width: "16.6%"}}>Gérée</th>
                                <th scope="col" style={{width: "16.6%"}}>Définie</th>
                                <th scope="col" style={{width: "16.6%"}}>Gérée de manière quantitative</th>
                                <th scope="col" style={{width: "16.6%"}}>Optimisée</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>0</td>
                                <td>1</td>
                                <td>2</td>
                                <td>3</td>
                                <td>4</td>
                                <td>5</td>
                                </tr>
                                <tr>
                                <td colSpan={6}>
                                    <GradientComponent
                                        labels={[]}
                                        descs={[]}
                                        colors={GradientStatus.getColors()}
                                        direction="to right"
                                        type='general'
                                    />
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            );

            htmlString.push(
                <>
                    <div className="appendix-details">
                        <p></p>
                        <Heading2 style={{marginTop: '5em'}}>Annexe A – Détails sur les références de l’ECM</Heading2>
                        <OntarioRow style={{marginBottom: '1.5em'}}>Cette autoévaluation de la cybermaturité a été réalisée et approuvée par les représentants autorisés énumérés ci-dessus, avec la contribution d’autres personnes au sein de l’organisation, le cas échéant.</OntarioRow>
                        <OntarioRow style={{marginBottom: '1.5em'}}>Pour évaluer la cybermaturité, l’ECM s’est appuyée sur plus de 100 énoncés du Cybersecurity Framework 2.0 du NIST. Le contenu de l’ECM a été adapté pour tenir compte des différences régionales et organisationnelles, avec l’autorisation du National Institute of Standards and Technology (2024).</OntarioRow>

                    </div>
                    <div className="nist-functions">
                        <span style={{fontWeight: 'bold'}}>Fonctions du CSF 2.0 du NIST</span>
                        <p> GOUVERNER – La stratégie, les attentes et la politique de gestion des risques de cybersécurité de l’organisation sont établies, communiquées et surveillées. </p>
                        <p> IDENTIFIER – Les risques actuels de cybersécurité de l’organisation sont compris. </p>
                        <p> PROTÉGER – Les mesures de protection pour gérer les risques de cybersécurité de l’organisation sont utilisées. </p>
                        <p> DÉTECTER – Les attaques et compromissions possibles en matière de cybersécurité sont détectées et analysées. </p>
                        <p> RÉPONDRE – Des mesures concernant un incident de cybersécurité détecté sont prises. </p>
                        <p> RÉCUPÉRER – Les actifs et les opérations affectés par un incident de cybersécurité sont restaurés. </p>
                    </div>  

                    <div className="ontario-table-div">
                        <table className="ontario-table--full-container-width" style={{ marginBottom: "3em" }}>
                            <thead>
                                <tr>
                                    <th scope="col">Cotation</th>
                                    <th scope="col">Niveaux de maturité</th>
                                    <th scope="col">Brève définition</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>0</td>
                                    <td>Aucune</td>
                                    <td>Il n’existe pas de mesures informelles ou réactives ni de gouvernance ou de pratiques consignées en matière de cybersécurité.</td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>Initiale</td>
                                    <td>Les processus existants sont ponctuels, imprévisibles, mal contrôlés et réactifs. Il y a peu, voire aucune structure de gouvernance officielle ni de politique de sécurité établie, et les contrôles varient considérablement d’une équipe à l’autre ou d’une organisation à l’autre.</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Gérée</td>
                                    <td>Il existe une gestion et une gouvernance des processus de base. Toutefois, les améliorations sont réactives et les normes et contrôles ne sont pas appliqués de manière uniforme.</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Définie</td>
                                    <td>Les processus sont normalisés, intégrés et communiqués dans l’ensemble de l’organisation. Ils sont définis, consignés et mis en œuvre comme prévu, par exemple au moyen d’un cadre commun ou d’un document de référence.</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Gérée de manière quantitative</td>
                                    <td>Il existe un suivi et une mesure régulière des performances, et les risques sont prévus à l’aide d’indicateurs et d’une analyse des tendances. L’amélioration continue est guidée par des informations fondées sur des données.</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Optimisée</td>
                                    <td>L’amélioration continue est ancrée dans la culture et l’harmonisation organisationnelles. L’organisation innove de manière proactive, en anticipant les risques futurs et en s’adaptant rapidement.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </>
            );
        }

        htmlString.push(
            <Button id="cma-download-btn" label={this.props.isEng ? "Download report" : "Télécharger le rapport"} onClick={this.downloadReportPDF} className="ontario-margin-top-24-!" />
        )

        return htmlString;
    }
}